// @flow
import type { AppointmentSettings } from 'types/appointment-settings'

import { API } from './api'
import { makeGetRequest, makePostRequest } from './fetchCalls'

export type SchedulerData = {
  available_time_slots: Array<{
    date: string,
    end_date: string,
    end_time: string,
    start_time: string,
    weekday: number,
  }>,
}

export function getAppointmentSettings(
  messageCode: string
): Promise<AppointmentSettings> {
  return makeGetRequest(API.SCHEDULER.APPOINTMENT_SETTINGS(messageCode))
}

export function getSchedulerData(queryParams: {
  appointment_type_id: number,
  message_code: string,
  start_date: string,
}): Promise<SchedulerData> {
  //$FlowFixMe - flow doesn't handle URLSearchParams very well
  const queryString = new URLSearchParams(queryParams).toString()

  return makeGetRequest(`${API.SCHEDULER.ROOT}?${queryString}`)
}

export function createAppointment(data: {
  appointment_type: number,
  message_code: string,
  scheduled_date: string,
}): Promise<void> {
  return makePostRequest(API.SCHEDULER.CREATE_APPOINTMENT, {
    body: JSON.stringify(data),
  })
}
